import styled from 'styled-components';

export const CompanyAddressContainer = styled.section`
  width: 100%;
  max-width: 820px;

  display: flex;
  flex-direction: column;
  gap: var(--space-l);

  margin: 0 auto;
`;

export const CompanyAddressHeader = styled.div`
  width: 100%;

  display: flex;
  align-items: flex-start;
  gap: var(--space-m);

  padding-bottom: var(--space-l);

  border-bottom: 1px solid var(--grey1);

  @media screen and (max-width: 600px) {
    gap: var(--space-s);
    padding-bottom: var(--space-m);
  }
`;

export const CompanyAddressHeaderIcon = styled.div`
  width: 46px;
  height: 46px;
  min-width: 46px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(234, 154, 38, 0.1);
  color: var(--orange4);

  border-radius: 12px;

  svg {
    font-size: 1rem;
  }

  @media screen and (max-width: 600px) {
    width: 40px;
    height: 40px;
    min-width: 40px;

    border-radius: 10px;

    svg {
      font-size: 0.9rem;
    }
  }
`;

export const CompanyAddressHeaderContent = styled.div`
  min-width: 0;

  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  > div {
    display: flex;
    align-items: center;
    gap: var(--space-xs);

    > span:first-child {
      color: var(--orange4);

      font-size: 0.68rem;
      font-weight: 800;
      letter-spacing: 0.07em;
      line-height: 1.2;
      text-transform: uppercase;
    }
  }

  h2 {
    margin: 0;

    color: var(--grey7);

    font-size: clamp(1.35rem, 2vw, 1.7rem);
    font-weight: 800;
    letter-spacing: -0.025em;
    line-height: 1.25;
  }

  p {
    max-width: 620px;

    margin: 0.15rem 0 0;

    color: var(--grey4);

    font-size: 0.85rem;
    line-height: 1.55;
  }

  @media screen and (max-width: 600px) {
    h2 {
      font-size: 1.2rem;
    }

    p {
      font-size: 0.78rem;
    }
  }
`;

export const CompanyAddressOptional = styled.span`
  padding: 0.25rem 0.5rem;

  background: var(--grey0);
  color: var(--grey4);

  border: 1px solid var(--grey1);
  border-radius: 100px;

  font-size: 0.6rem;
  font-weight: 750;
  letter-spacing: 0;
  line-height: 1.2;
  text-transform: none;
`;

export const CompanyAddressFields = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: var(--space-m);
`;

export const CompanyAddressFieldRow = styled.div`
  width: 100%;

  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-m);

  > * {
    min-width: 0;
  }

  @media screen and (max-width: 650px) {
    grid-template-columns: 1fr;
  }
`;

export const CompanyAddressNotice = styled.div`
  width: 100%;

  display: flex;
  align-items: flex-start;
  gap: var(--space-s);

  padding: var(--space-m);

  background: ${({ $warning }) =>
    $warning ? 'rgba(234, 154, 38, 0.06)' : 'rgba(253, 220, 94, 0.08)'};

  border: 1px solid
    ${({ $warning }) =>
      $warning ? 'rgba(234, 154, 38, 0.25)' : 'rgba(253, 220, 94, 0.3)'};

  border-radius: 12px;

  @media screen and (max-width: 600px) {
    padding: var(--space-s);
  }
`;

export const CompanyAddressNoticeIcon = styled.div`
  width: 32px;
  height: 32px;
  min-width: 32px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: ${({ $warning }) =>
    $warning ? 'rgba(234, 154, 38, 0.1)' : 'rgba(253, 220, 94, 0.18)'};

  color: var(--orange4);

  border-radius: 8px;

  svg {
    font-size: 0.75rem;
  }
`;

export const CompanyAddressNoticeContent = styled.div`
  min-width: 0;

  display: flex;
  flex-direction: column;
  gap: 0.15rem;

  strong {
    color: var(--grey7);

    font-size: 0.78rem;
    font-weight: 750;
    line-height: 1.4;
  }

  p {
    max-width: 650px;

    margin: 0;

    color: var(--grey4);

    font-size: 0.74rem;
    line-height: 1.5;
  }
`;

export const CompanyAddressActions = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-m);

  margin-top: var(--space-s);
  padding-top: var(--space-m);

  border-top: 1px solid var(--grey1);

  > div,
  > a {
    margin: 0;
  }

  @media screen and (max-width: 650px) {
    flex-direction: column-reverse;
    align-items: stretch;

    > div,
    > a,
    button {
      width: 100%;
    }
  }
`;

export const CompanyAddressSecondaryActions = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-s);

  @media screen and (max-width: 650px) {
    width: 100%;

    display: grid;
    grid-template-columns: 1fr 1fr;
  }
`;

export const CompanyAddressBackButton = styled.button`
  padding: var(--space-s) var(--space-m);

  background: transparent;
  color: var(--grey5);

  border: 1px solid var(--grey2);
  border-radius: var(--borderRadiusSmall);

  font: inherit;
  font-size: 0.82rem;
  font-weight: 700;

  cursor: pointer;

  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease;

  &:hover {
    background: var(--grey0);
    color: var(--grey7);
    border-color: var(--grey3);
  }
`;

export const CompanyAddressSkipButton = styled.button`
  padding: var(--space-s) var(--space-m);

  background: transparent;
  color: var(--orange4);

  border: 0;

  font: inherit;
  font-size: 0.82rem;
  font-weight: 750;

  cursor: pointer;

  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }
`;
